//HRMS env

export const environment = {
  clientId: "rewardrally-api",
  clientSecret: "wJv9GJ2CRfORJU3IobGiW9rVH2Gb2x0x",
  gamification: {
    userId: "1048814261",
    gameId: "65ae60d6f0275d9cffa140c8",
    applicationId: "65ae5de4f0275dc7b2a13571",
    profileSubmissionAction: "65ae60d6f0275d9cffa140c8",
    competancySubmissionAction: "65ae60fff0275d5f1aa14164",
    workHistorySubmissionAction: "65ae6110f0275d0c4fa1417b",
    timeSheetSubmission: "65ae6121f0275d8c51a1419f",
    casualLeaveAction: "65ae617cf0275df7f9a142c9",
    earnedLeaveAction: "65ae6191f0275dd6b8a142f6",
    linkedinAction: "6901b72cf82392409ea1bfec",
  },
  baseUrl: "https://gamifyapi.rewardrally.in",
  rapidBaseUrl: "https://linkedin-jobs-data-api.p.rapidapi.com",
  // rapidApiKey: "e28a9af2b6mshff2d3f13a5e2f03p18f0c6jsn4f9170129964",
  rapidApiKey: "120468ea3bmshae87b2680fed471p1f6467jsnd0acae813260", //1.Backup Key
  // rapidApiKey: "04f60f5e5cmsh90c5f877f2115d6p10c96bjsn2d6715d238d8", //2.Backup Key
  searchHashtag: "#TechXRR",
};
